<nav
  class="side-nav"
  [ngClass]="{ 'side-nav--collapsed': !expanded }"
  data-track
  [attr.data-track-group]="currentCourtSystemId ? 'side-nav-internal' : 'side-nav-external'"
  aria-label="Main navigation"
>
  <a class="side-nav__skip-nav" ftrFocusableNoopAnchor (click)="skipToMainContent()">Skip to main content</a>
  @if (selectedNestedItem()) {
    <div class="branch-side-nav">
      <div class="branch-side-nav__header">
        <ng-container *ngTemplateOutlet="menuCloseButtonTemplate" />
        @if (showBranchBackButton) {
          <button
            class="branch-side-nav__title branch-side-nav__btn"
            type="button"
            ftrButton
            color="grey"
            [fullWidth]="true"
            [title]="selectedNestedItem()?.title"
            (click)="popNestedNavItems()"
          >
            <ftr-icon-legacy icon="ChevronLeft" size="Small" />
            <div class="side-nav__item-title">
              {{ selectedNestedItem()?.title }}
            </div>
          </button>
        } @else {
          <div class="branch-side-nav__title_no_back">
            <div class="side-nav__item-title">
              {{ selectedNestedItem()?.title }}
            </div>
          </div>
        }
      </div>
      <div class="branch-side-nav__body">
        @for (navItem of selectedNestedItem()?.children; track trackBy($index, navItem)) {
          <ng-container *ngTemplateOutlet="navItemTemplate; context: { $implicit: navItem }" />
        }
      </div>
    </div>
  } @else {
    @if (isLoading) {
      <div class="side-nav__header-skeleton">
        <div
          class="side-nav__header-skeleton-row"
          [ngClass]="{ 'side-nav__header-skeleton-row--collapsed': !expanded }"
        >
          <div class="side-nav__loading-circle" [ngClass]="{ 'side-nav__loading-circle-collapsed': !expanded }"></div>
          <div class="side-nav__loading" [ngClass]="{ 'side-nav__loading-collapsed': !expanded }"></div>
        </div>
        <div
          class="side-nav__header-skeleton-subrow"
          [ngClass]="{ 'side-nav__header-skeleton-subrow--collapsed': !expanded }"
        >
          <div class="side-nav__loading-circle" [ngClass]="{ 'side-nav__loading-circle-collapsed': !expanded }"></div>
          <div class="side-nav__loading" [ngClass]="{ 'side-nav__loading-collapsed': !expanded }"></div>
        </div>
      </div>
    } @else {
      <header
        class="side-nav__header"
        [class.side-nav__header--overlay]="displayMode === 'OVERLAY'"
        [class.side-nav__header--collapsed]="!expanded"
      >
        @if (displayMode === 'OVERLAY') {
          <ng-container *ngTemplateOutlet="menuCloseButtonTemplate" />
        }
        <ng-content select="[sideNavHeader]" />
      </header>
      <div class="side-nav__subheader">
        <ng-content select="[sideNavSubHeader]" />
      </div>
    }
    @if (displayMode === 'DEFAULT') {
      <button
        class="side-nav__expand-btn"
        type="button"
        ftrButton
        displayType="icon"
        [autoWidth]="true"
        (click)="expandedToggled.emit()"
        ftrTooltip
        [title]="expanded ? 'Collapse Navigation Menu' : 'Expand Navigation Menu'"
        [attr.aria-label]="expanded ? 'Collapse Navigation Menu' : 'Expand Navigation Menu'"
        [message]="expanded ? 'Collapse' : 'Expand'"
        [showDash]="false"
        position="right"
        [forceDisplayState]="isExpandButtonHovered() ? undefined : 'hide'"
        (mouseenter)="isExpandButtonHovered.set(true)"
        (mouseleave)="isExpandButtonHovered.set(false)"
      >
        <ftr-icon-legacy
          [icon]="expanded ? 'ChevronLeft' : 'ChevronRight'"
          [title]="expanded ? 'Collapse Navigation' : 'Expand Navigation'"
          align="TextTop"
        />
      </button>
    }
    <div
      class="side-nav__body"
      [class.side-nav__body--stable-gutter]="isFirefox()"
      [ngClass]="{
        'side-nav__body--padding': publicNavigationEnabled(),
        'side-nav__body--legacy-padding': !publicNavigationEnabled(),
      }"
    >
      @if (isLoading) {
        @for (loadingNavGroup of loadingSideNavGroups; track trackBy($index, loadingNavGroup)) {
          <div class="side-nav__group">
            <ng-container *ngTemplateOutlet="navGroupLoadingTemplate; context: { $implicit: loadingNavGroup }" />
          </div>
        }
      } @else {
        @for (navGroup of navGroups(); track trackBy($index, navGroup)) {
          <div class="side-nav__group" [class.side-nav__group--branch]="selectedNestedItem()">
            <div class="side-nav__group-header">
              @if (navGroup.title; as navGroupTitle) {
                <div class="side-nav__group-title" [ngClass]="{ 'side-nav__group-title--collapsed': !expanded }">
                  {{ navGroupTitle }}
                </div>
              }
              @if (navGroup.title === 'Favorites' && currentCourtSystemId) {
                <ftr-favorites-menu
                  [courtSystemId]="currentCourtSystemId"
                  [collapsed]="!expanded"
                  [displayMode]="displayMode"
                  (dropDownOpened)="onFavoritesDropdownOpened($event)"
                />
              }
            </div>
            @if (!navGroup.isLoading) {
              <ng-container *ngTemplateOutlet="navGroupTemplate; context: { $implicit: navGroup }" />
            } @else {
              <ng-container *ngTemplateOutlet="navGroupLoadingTemplate; context: { $implicit: navGroup }" />
            }
          </div>
        }
      }
    </div>
    <div class="side-nav__footer">
      <div class="side-nav__group">
        <div class="side-nav__group-body">
          @for (footerItem of footerItems(); track footerItem) {
            @if (!footerItem.displayMode || footerItem.displayMode === displayMode) {
              <ng-container *ngTemplateOutlet="navItemTemplate; context: { $implicit: footerItem }" />
            }
          }
          @if (displayMode === 'DEFAULT') {
            <ng-container *ngTemplateOutlet="helpAndSupportNavItem" />
          }
        </div>
      </div>
    </div>
  }

  @if (currentCourtSystemId) {
    <ftr-favorites-edit-modal [courtSystemId]="currentCourtSystemId" />
  }
</nav>

<ng-template #navGroupTemplate let-navGroup>
  <div class="side-nav__group-body">
    @for (navItem of navGroup.items; track trackBy($index, navItem)) {
      @if (!navItem.displayMode || navItem.displayMode === displayMode) {
        <ng-container
          *ngTemplateOutlet="navItemTemplate; context: { $implicit: navItem, groupTitle: navGroup.title }"
        />
      }
    }
  </div>
</ng-template>

<ng-template #navGroupLoadingTemplate let-navGroup>
  <div class="side-nav__group-body">
    @for (idx of [33, 66, 99]; track idx) {
      <div
        class="side-nav__loading"
        [ngClass]="{ 'side-nav__loading-collapsed': !expanded }"
        [style.width]="
          expanded ? loadingWidths[((navGroup.title ? navGroup.title.length : 10) * idx) % loadingWidths.length] : null
        "
      ></div>
    }
  </div>
</ng-template>

<ng-template #navItemTemplate let-navItem let-groupTitle="groupTitle">
  @if (navItem.type === 'LINK') {
    <a
      class="side-nav__item"
      [title]="navItem.title"
      ftrTooltip
      [attr.aria-label]="
        'Main Navigation, ' + (groupTitle ? ' Group ' + groupTitle + ', ' : '') + ' Link ' + navItem.title
      "
      [message]="navItem.tooltipHint || navItem.title"
      [showDash]="false"
      [position]="displayMode === 'OVERLAY' ? 'above' : 'right'"
      [forceDisplayState]="displayMode === 'OVERLAY' && !isOpened ? 'hide' : undefined"
      [hideIfNotOverflowing]="expanded || isOpened"
      (click)="handleOnNavItemClick(navItem)"
      [routerLink]="navItem.path"
      [queryParams]="navItem.queryParams"
      [routerLinkActiveOptions]="{
        paths: 'exact',
        matrixParams: 'ignored',
        queryParams: groupTitle === 'Favorites' ? 'exact' : 'ignored',
        fragment: 'ignored',
      }"
      routerLinkActive="side-nav__item--selected"
    >
      <ng-container *ngTemplateOutlet="navItemInner; context: { $implicit: navItem }" />
    </a>
  } @else if (navItem.title === helpCenterNavTitle) {
    <button
      ftrElevioTrigger
      [articleId]="elevioArticleId()"
      class="side-nav__item"
      type="button"
      ftrButton
      color="grey"
      [fullWidth]="true"
      [title]="navItem.title"
      ftrTooltip
      [message]="navItem.tooltipHint || navItem.title"
      [showDash]="false"
      [position]="displayMode === 'OVERLAY' ? 'above' : 'right'"
      [forceDisplayState]="displayMode === 'OVERLAY' && !isOpened ? 'hide' : undefined"
      [hideIfNotOverflowing]="expanded || isOpened"
    >
      <ng-container *ngTemplateOutlet="navItemInner; context: { $implicit: navItem }" />
      @if (navItem.type === 'BRANCH') {
        <ftr-icon-legacy class="side-nav__item-end" icon="ChevronRight" size="Small" />
      }
    </button>
  } @else {
    <button
      class="side-nav__item"
      type="button"
      ftrButton
      color="grey"
      [fullWidth]="true"
      [title]="navItem.title"
      ftrTooltip
      [message]="navItem.tooltipHint || navItem.title"
      [showDash]="false"
      [position]="displayMode === 'OVERLAY' ? 'above' : 'right'"
      [forceDisplayState]="displayMode === 'OVERLAY' && !isOpened ? 'hide' : undefined"
      [hideIfNotOverflowing]="expanded || isOpened"
      (click)="handleOnNavItemClick(navItem)"
    >
      <ng-container *ngTemplateOutlet="navItemInner; context: { $implicit: navItem }" />
      @if (navItem.type === 'BRANCH') {
        <ftr-icon-legacy class="side-nav__item-end" icon="ChevronRight" size="Small" />
      }
    </button>
  }
</ng-template>

<ng-template #navItemInner let-navItem>
  @if (navItem.logoUrl) {
    <img [src]="navItem.logoUrl" [alt]="'Logo for ' + navItem.title" />
  } @else if (navItem.icon) {
    <ftr-icon-legacy
      [icon]="navItem.icon"
      size="Small"
      [title]="expanded ? navItem.title : navItem.tooltipHint || navItem.title"
    />
  }
  <div class="side-nav__item-title-wrapper" [ngClass]="{ 'side-nav__item-title-wrapper--collapsed': !expanded }">
    <div class="side-nav__item-title">
      {{ navItem.title }}
    </div>
    <div class="side-nav__item-title-spacer"></div>
  </div>
</ng-template>

<ng-template #helpAndSupportNavItem let-navItem>
  <button
    class="side-nav__item"
    type="button"
    ftrButton
    color="grey"
    [fullWidth]="true"
    [class.side-nav__item--selected]="helpAndSupportPopover.isOpen()"
    [attr.aria-label]="'Main Navigation, Help & Support'"
    ftrTooltip
    message="Help & Support"
    [showDash]="false"
    position="right"
    [forceDisplayState]="expanded ? 'hide' : undefined"
    (click)="helpAndSupportPopover.toggle()"
    #helpAndSupportPopover="ngbPopover"
    [ngbPopover]="helpAndSupportTemplate"
    [animation]="false"
    triggers="manual"
  >
    <ng-container
      *ngTemplateOutlet="
        navItemInner;
        context: {
          $implicit: {
            icon: elevioHelpIcon(),
            title: 'Help & Support',
          },
        }
      "
    />
  </button>
</ng-template>

<ng-template #helpAndSupportTemplate>
  <ftr-help-sub-menu-flyout-card [helpMenuConfig]="helpMenuConfig()" />
</ng-template>

<ng-template #menuCloseButtonTemplate>
  <button
    class="branch-side-nav__btn"
    type="button"
    ftrButton
    color="grey"
    [autoWidth]="true"
    (click)="closeSideBar()"
    title="Collapse Navigation Menu"
    aria-label="Collapse Navigation Menu"
  >
    <ftr-icon-legacy icon="Close" align="Middle" size="Regular" />
  </button>
</ng-template>
